import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/reset.css";
import { createPinia, Pinia } from "pinia";

const pinia: Pinia = createPinia();

createApp(App).use(pinia).use(Antd).use(router).mount("#app");
